/* eslint-disable react/react-in-jsx-scope */
import { 
    useEffect, 
    useState 
} from 'react';
import CarouselSlide from '../components/carouselSlide'
import axios from 'axios';

const apiurl = `${process.env.REACT_APP_API}/products.php`
const products = [
  {
    id: 1,
    name: 'Cake browny',
    price: '129฿',
    instock: '200',
    href: '#',
    description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
    img:'https://theunlikelybaker.com/wp-content/uploads/2017/10/Chocolate-Chiffon-Cake-Recipe-Feature.jpg',
    date: 'Mar 16, 2020',
    datetime: '2020-03-16',
    category: 'Cakes',
  },
  {
    id: 2,
    name: 'chiffon-cake',
    price: '89฿',
    instock: '159',
    href: '#',
    description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
    img:'https://cookingwithdog.com/wp-content/uploads/2021/03/chiffon-cake-00-1615696212.9265.jpg',
    date: 'Mar 10, 2020',
    datetime: '2020-03-10',
    category: 'Chiffon',
  },
  {
      id: 3,
    name: 'Yellow Bowl Chiffon',
    price: '79฿',
    instock: '179',
    href: '#',
    description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
    img:'https://assets.epicurious.com/photos/627aaf5f080d9862e3bda7d6/1:1/w_2560%2Cc_limit/PandanChiffon_RECIPE_050522_33403.jpg',
    date: 'Mar 12, 2020',
    datetime: '2020-03-12',
    category: 'Bakery',
  },
  {
    id: 4,
    name: 'Cake browny',
    price: '109฿',
    instock: '159',
    href: '#',
    description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
    img:'https://www.allrecipes.com/thmb/JaPmyuRaOPDlGkkk0FwLKu2eoSo=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/7892-chiffon-cake-ddmfs-11960-4x3-31cd0f36773640b193318e76a978cc0a.jpg',
    date: 'Mar 16, 2020',
    datetime: '2020-03-16',
    category: 'Cakes',
  },  
  {
    id: 5,
    name: 'Cake browny',
    price: '129฿',
    instock: '200',
    href: '#',
    description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
    img:'https://theunlikelybaker.com/wp-content/uploads/2017/10/Chocolate-Chiffon-Cake-Recipe-Feature.jpg',
    date: 'Mar 16, 2020',
    datetime: '2020-03-16',
    category: 'Cakes',
  },
];

function CartsCustomer() {
    const [cart, setCart] = useState(null);
    const [data, setData] = useState(null);

    
    useEffect(() => {
      const fetchRecommend = async () => {
        try {
          const result = await axios.get(`${apiurl}?mode=getrecommend`);
          
          // console.log(result);
          // console.log(result.data);
          // if(result.data.length>0) {
          if(result.data && result.data[0].length>0) {  
            // const data = await response.json();
            // console.log(result.data[0]);
            setData(result.data[0]);
            return result.data[0];
          } //else {
            // setData(products);
          //}
        }
        catch(err) {
            console.log(err);
          }
        }
    
        fetchRecommend();
      
    },[])   

    // function currencyFormat(num) {
    //   return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '1,') + '฿'
    // };
    function numberWithCommas (nStr) {
      nStr = nStr.toFixed(2) + '';
      let x = nStr.split('.');
      let x1 = x[0];
      let x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      x = x1 + x2;
      if(x.substr(0,1) === '.'){
          x = '0' + x;
      }
      return x + '฿';
  };


    // useEffect(() => {  
      window.onstorage = () => {
        // When local storage changes, dump the list to
        // the console.
        const cartStore = window.localStorage.getItem("cart");
        if (cartStore !== null) {
            // console.log(JSON.parse(cartStore));
            setCart(JSON.parse(cartStore)); 
          } else setCart(null);

      };
             
  return (
    <div className="text-white">
      {cart !==null ? (
        <div className="flex flex-col p-2 justify-center">
          <div className="flex flex-col items-center justify-center mt-1 text-lg font-bold">
              {/* <img src="/logo-720b.png" alt="Online Market" className="w-48" /> */}
              <p>Molthana Bakery.</p>
              <p className="text-xs">โทร: 035-559779 , Line ID: 0869863509.</p>
          </div>
          <div className="flex justify-center text-sm font-bold ">
            <span>รายการสินค้า</span>
          </div>
          <table className="w-full table-auto ">
            <caption className="caption-bottom items-center py-4 text-lg justify-center font-bold">
              *** ขอบคุณที่ใช้บริการ ***
            </caption> 
          <thead>
              <tr className="border border-slate-300 p-2">
                <th>Item</th>
                <th className="">Qty</th>
                <th className="">Unit/Price</th>
                <th className="">Total</th>
              </tr>
            </thead>
            <tbody>
            {cart[0]?.cart.map((product,item) => (
              <tr key={item} >
                <td className="pl-2">{`${item+1}. ${product.name}`}</td>
                <td className="text-center ">{product.quantity}</td>
                <td className="text-right pr-2 ">{product.price}</td>
                <td className="text-right pr-2 "> {product.price*product.quantity}</td>
              </tr>
            ))}
            <tr key="Subtotal" className="border-t-2 ">
              <td rowSpan="4" className="" >
                <div className="flex items-center justify-center">
                  <img src="/qrpayment.jpeg" alt="Molthana Bakery" className="w-full rounded-lg mx-auto max-w-48 overflow-hidden" />
                </div>
              </td>
              <td className=" text-left border-b-2 pl-2 border-slate-300">Subtotal</td>
              <td className=" text-right pr-2  border-b-2 border-slate-300"></td>
              <td className="text-right pr-2  border-b-2 border-slate-300">{numberWithCommas(parseFloat(cart[0]?.subtotal))}</td>
            </tr>
            <tr key="discount" className="">
              {/* <td className=" text-left  border-b-2 border-slate-300"></td> */}
              <td className=" text-left pl-2 border-b-2 border-slate-300">
                Discount
              </td>
              {cart[0]?.discount1>0 ? (
                  <td className=" text-right pr-2  border-b-2 border-slate-300">{cart[0]?.discount1}%</td>
                ) :
                (
                  <td className=" text-right pr-2  border-b-2 border-slate-300"></td>
                )
              }
              <td className="text-right pr-2  border-b-2 border-slate-300">{cart[0]?.discountrate}฿</td>
            </tr>
            <tr key="vat" className="">
              {/* <td></td> */}
              <td className=" text-left  border-b-2 pl-2 border-slate-300">Vat</td>
              {cart[0]?.vat>0 ? (
                  <td className=" text-right pr-2  border-b-2 border-slate-300">{cart[0]?.vat}%</td>
                ) :
                (
                  <td className=" text-right pr-2  border-b-2 border-slate-300"></td>
                )
              }
              <td className="text-right pr-2  border-b-2 border-slate-300">{cart[0]?.taxe}฿</td>
            </tr>
            <tr key="total" className=" ">
              {/* <td ></td> */}
              <td className=" text-left border-b-2 pl-2 border-slate-300">Total</td>
              <td className=" text-right pr-2  border-b-2 border-slate-300"></td>
              <td className="text-right pr-2 text-2xl font-bold border-b-2 border-slate-300">{numberWithCommas(parseFloat(cart[0]?.total))}</td>
            </tr>
            </tbody>
          </table>
        </div>

      ) : (
        <div className=" p-4">
          <div className="flex flex-col p-8 text-center justify-center text-2xl font-bold">
            <span>Molthana Bakery</span>
            <span> ยินดีต้อนรับ.</span>
          </div>
          
          <div className="flex items-center justify-center rounded-xl max-w-7xl p-4 mt-4 xl:mt-8 mx-auto bg-cover bg-center" style={{backgroundImage: 'url(/special-recipe.jpg)'}}>
            {data && (
              <div className="w-full">
                <CarouselSlide slides={data} autoSlide={true} autoSlideInterval={10000} />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default CartsCustomer